import baseTheme from "@insite/mobius/globals/baseTheme";
import { ModalPresentationProps } from "@insite/mobius/Modal";
import getColor from "@insite/mobius/utilities/getColor";
import { buttonIconOnlyCommonStyles } from "@solveindustrial/Utilities/styleguide";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

export const modal: {
    sizeVariants: {
        small: number;
        medium: number;
        large: number;
    };
    defaultProps?: ModalPresentationProps;
} = {
    sizeVariants: {
        small: 500,
        medium: 800,
        large: 1110,
    },
    defaultProps: {
        cssOverrides: {
            modalTitle: css`
                border-bottom: 1px solid ${getColor(colorStrings.commonBorder)};
                padding: 16px !important;
                ${mediaQueriesBP.minMD} {
                    padding: 24px !important;
                }
            `,
            modalContainer: css`
                box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
            `,
            modalContent: css`
                font-size: 16px;
                line-height: 19px;

                p {
                    font-size: 16px;
                    line-height: 19px;

                    ${mediaQueriesBP.minMD} {
                        font-size: 18px;
                        line-height: 12px;
                    }
                }

                padding: 16px !important;
                margin: 0;
                ${mediaQueriesBP.minMD} {
                    padding: 24px !important;
                    font-size: 18px;
                    line-height: 12px;
                }
            `,
        },
        closeButtonProps: {
            ...buttonIconOnlyCommonStyles,
        },
        closeButtonIconProps: {
            src: "X",
            size: 20,
        },
        headlineTypographyProps: {
            weight: "bold",
            variant: "h2",
            css: css`
                padding: 16px !important;
                ${mediaQueriesBP.minMD} {
                    padding: 24px !important;
                }
            `,
        },
        mergeCss: true,
    },
};
